import { FLOW_STATUS, type FlowSummary } from '@/lib/api/email-flows';

/**
 * Determine if a flow is active or draft
 * A flow is active if:
 * 1. Flow status is 'published'
 * 2. At least one email in the flow is published
 */
export function getFlowStatus(flow: FlowSummary): 'active' | 'draft' {
    const hasPublishedEmail = flow.flow_emails?.some(email => email.status === FLOW_STATUS.PUBLISHED);

    if (flow.status === FLOW_STATUS.PUBLISHED && hasPublishedEmail) {
        return 'active';
    }

    return 'draft';
}

/**
 * Get display text for flow status
 */
export function getFlowStatusText(status: 'active' | 'draft'): string {
    return status === 'active' ? 'Active' : 'Draft';
}

/**
 * Check if a flow can be published
 * A flow can be published if it has at least one email
 */
export function canPublishFlow(flow: FlowSummary): boolean {
    return (flow.flow_emails?.length ?? 0) > 0;
}

/**
 * Check if a flow can be unpublished
 * A flow can be unpublished if it hasn't started yet
 */
export function canUnpublishFlow(flow: FlowSummary): boolean {
    return !flow.data?.started;
}

/**
 * Check if a flow can be deleted
 * A flow can be deleted if it hasn't started yet
 */
export function canDeleteFlow(flow: FlowSummary): boolean {
    return !flow.data?.started;
}
